import Vue from 'vue'
import Vuex from 'vuex'
import { getApp, setApp } from '@/utils/app'
import { getAcc, setAcc } from '@/utils/acc'
import { getUser, setUser, getRedbagUser, setRedbagUser } from '@/utils/user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    app: getApp(),
  	user: getUser(),
    acc: getAcc(),
    answer_reslut: {
      point: '-',
      user_time: '-'
    },
    rebbag_user: getRedbagUser(),
    luosimao_code: ''
  },
  mutations: {
  	SET_APP: (state, app) => {
      setApp(app)
			state.app = app
		},
  	SET_ACC: (state, acc) => {
      setAcc(acc)
			state.acc = acc
		},
    SET_USER: (state, user) => {
      setUser(user)
      state.user = user
    },
    SET_ANSWER_RESULT: (state, info) => {
      state.answer_reslut = info
    },
    SET_LUOSIMAO_CODE: (state, info) => {
      state.luosimao_code = info
    },
    SET_REBBAG_USER: (state, info) => {
      setRedbagUser(info)
      state.rebbag_user = info
    }
  },
  actions: {
  	setAPP({ commit }, app) {
  	  commit('SET_APP', app)
  	},
    SET_ACC({ commit }, info) {
      commit('SET_ACC', info)
    },
    SET_ANSWER_RESULT({ commit }, info) {
      commit('SET_ANSWER_RESULT', info)
    },
    SET_REBBAG_USER({ commit }, info) {
      commit('SET_REBBAG_USER', info)
    },
    setUSER({ commit }, user) {
      commit('SET_USER', user)
    },
    SET_LUOSIMAO_CODE({ commit }, user) {
      commit('SET_LUOSIMAO_CODE', user)
    }
  },
  modules: {
  }
})
